import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  mergeAlertsToCaseFail,
  mergeAlertsToCaseSuccess,
  MERGE_ALERTS_TO_CASE
} from '../../redux/actions/cm/mergeAlertsToCase';
import { mergeAlertsToCase } from '../../services/cm/alerts';

function* mergeAlertsToCaseWorker({ alertIds, caseId }) {
  try {
    // FIN-13021 — `skippedUnknown` are ids with no `alert` row; without surfacing them the
    // analyst sees a silent short merge.
    const {
      assignedDepartmentId,
      merged,
      skippedAlreadyCased,
      skippedUnknown
    } = yield call(mergeAlertsToCase, { alertIds, caseId });
    yield put(
      mergeAlertsToCaseSuccess({
        assignedDepartmentId,
        merged,
        skippedAlreadyCased,
        skippedUnknown
      })
    );
  } catch (error) {
    // FIN-12953 — prefer the BE's typed error body (e.g. "Case 999999 not found.") over the
    // generic axios message so the toast is actionable.
    yield put(
      mergeAlertsToCaseFail({
        message: error?.response?.data?.error || error?.message
      })
    );
  }
}

export function* watchMergeAlertsToCase() {
  yield takeEvery(
    MERGE_ALERTS_TO_CASE,
    function* ({ payload: { alertIds, caseId } }) {
      yield fork(mergeAlertsToCaseWorker, { alertIds, caseId });
    }
  );
}
